import Vue from 'vue'
import types from './types'
import { includes } from 'lodash'
import moment from 'moment'

export default {
  [types.mutations.add]: (state, planningitem) => {
    if (!state.planningitems.some(x => x.key === planningitem.key)) {
      if (planningitem.period) {
        planningitem.period = moment(planningitem.period.toDate())
      }
      state.planningitems.push(planningitem)
    }
  },
  [types.mutations.edit]: (state, planningitem) => {
    var y = state.planningitems.filter(x => x.key === planningitem.key)[0]
    if (planningitem.period) {
      planningitem.period = moment(planningitem.period)
    }
    Vue.set(state.planningitems, state.planningitems.indexOf(y), planningitem)
  },
  [types.mutations.delete]: (state, planningitem) => {
    var toDelete = state.planningitems.filter(x => x.key === planningitem.key)[0]
    state.planningitems.splice(state.planningitems.indexOf(toDelete), 1)
  },
  [types.mutations.deleteCultivation]: (state, { planningitem, cropIDs }) => {
    const toDelete = state.planningitems.filter(x =>
      x.ID === planningitem.ID &&
      x.methodID === planningitem.methodID &&
      includes(cropIDs, x.cropID) &&
      (!planningitem.actionID || planningitem.actionID === x.actionID)
    )
    toDelete.forEach(x => state.planningitems.splice(state.planningitems.indexOf(x), 1))
  },
  [types.mutations.deleteAll]: (state) => {
    state.planningitems.splice(0)
  },
  [types.mutations.setLastItemKey]: (state, { selection, key }) => {
    state.lastItemKeys[selection] = key
  }
}
